import { ProviderCredentialV2ListItem } from '../../../integrated-client/models/';

interface ITableData {
  records: Array<ProviderCredentialV2ListItem>;
  totalItems?: number;
}

export class TableData implements ITableData {
  records: Array<ProviderCredentialV2ListItem>;
  totalItems?: number;

  constructor() {
    this.records = [];
  }
}
